import { TgkFormAmountSourceProps } from "./TgkFormAmountSourcePanel";
import React, { useEffect, useState } from "react";
import { FormTreeSelection } from "../../cpm/FormTree";
import { FormTable, SheetForm, TgkAmountObjectSource } from "../../interfaces/CoObject";
import { IComboBoxOption } from "@fluentui/react";
import { CoObjectSourcePanelStateData } from "../co-table-panel/CoObjectSourceTablePanel";

const useTgkFormAmountSourcePanel = (props: TgkFormAmountSourceProps) => {
  const {
    objectSource,
    updateSource,
    validateSource,
    selectDBAndFetchDefaultRoots,
    isFileExcelExisting,
    isComponentInstance,
    isLocked,
  } = props;
  const [stateData, setStateData] = React.useState<CoObjectSourcePanelStateData>();
  const [sheetsAreaChartMap] = useState(new Map<string, string[]>());
  const [cellInput, setCellInput] = useState("");

  useEffect(() => {
    setCellInput(objectSource.cell ? objectSource.cell : "");
    setStateData({
      areasItems: [],
      loading: true,
    });
  }, []);

  const onFormClick = (formSelection: FormTreeSelection) => {
    sheetsAreaChartMap.clear();
    const selectedForm = {
      code: formSelection.formCode,
      desc: formSelection.formDesc,
      oid: formSelection.key,
      oidPath: formSelection.oidPath,
    } as FormTable;

    const obj = {
      ...objectSource,
      form: selectedForm,
      sheet: null,
      area: null,
      cell: null,
      path: formSelection.oidPath,
    } as TgkAmountObjectSource;

    updateSource(obj, validateSource(obj), true);
  };

  const initAreas = (sheet: SheetForm) => {
    if (sheetsAreaChartMap) {
      sheetsAreaChartMap.forEach((value: string[], key: string) => {
        if (sheet && sheet.code == key) {
          const areaMap: IComboBoxOption[] = value?.map((area) => {
            return createIComboBoxFromAreas(area);
          });
          setStateData({
            ...stateData,
            areasItems: areaMap,
          });
        }
      });
    }
  };

  const createIComboBoxFromAreas = (areaValue: string): IComboBoxOption => {
    return {
      key: areaValue,
      text: areaValue,
    };
  };

  const selectSheetComboBox = (option: IComboBoxOption) => {
    const obj = {
      ...objectSource,
      sheet: { code: String(option.key), desc: option.text, uid: null },
      area: null,
      cell: null,
    } as TgkAmountObjectSource;

    updateSource(obj, validateSource(obj), true);
    initAreas({ code: String(option.key), desc: option.text } as SheetForm);
  };

  const setCell = (_event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    const upperCaseValue = newValue?.toUpperCase();
    setCellInput(upperCaseValue);
    const obj = {
      ...objectSource,
      cell: isCellValid(upperCaseValue) ? upperCaseValue : null,
    } as TgkAmountObjectSource;
    updateSource(obj, validateSource(obj), true);
  };

  const isCellValid = (text: string) => {
    const regex = /^[A-Z]{1,4}[1-9]\d{0,3}$/;
    return regex.test(text);
  };

  return {
    objectSource,
    onFormClick,
    selectSheetComboBox,
    initAreas,
    sheetsAreaChartMap,
    cellInput,
    setCell,
    selectDBAndFetchDefaultRoots,
    isFileExcelExisting,
    isComponentInstance,
    isLocked,
  };
};

export default useTgkFormAmountSourcePanel;
